export const TEMPLATE_FAMILIES = {
  royal_indian_wedding_mobile_video_v1: {
    id: "royal_indian_wedding_mobile_video_v1",
    label: "Royal Indian Wedding",
    description: "Premium 5-scene Indian wedding mobile video invitation.",
    eventType: "wedding",
    eventTypeLabel: "Wedding",
    styleFamily: "royal",
    styleFamilyLabel: "Royal",
    format: "mobile_video",
    formatLabel: "Mobile Video",
    category: "Wedding",
    assetFamilyId: "royal_wedding_mobile_video_v1",
    draftBuilder: "royal_wedding",
    defaultSceneCount: 5,
    supportedSceneCounts: [5],
    defaultSubeventTypes: ["mehendi", "sangeet", "wedding", "reception"],
    defaultTags: ["ai_draft", "creative_brief", "admin_generated"],
    defaultStyleTags: ["royal", "luxury", "traditional", "ai-draft"],
    defaultCultureText: "Indian wedding",
    defaultCopyStyle: "formal, warm",
    defaultForm: {
      template_name: "",
      event_type: "wedding",
      style_family: "royal",
      format: "mobile_video",
      scene_count: 5,
      palette_text: "maroon, antique gold, ivory",
      palette_primary: "#5a1029",
      palette_secondary: "#8a1738",
      palette_accent: "#d4af37",
      palette_background: "#2d0817",
      palette_text_color: "#fff2d4",
      style_preset_id: "maroon-gold-palace",
      style_prompt:
        "Create a royal Indian wedding mobile video invitation with a premium palace feel. Keep the opening grand and details pages readable.",
      mood_text: "regal, cinematic, traditional",
      typography_direction: "Elegant serif display typography with clean readable detail text.",
      ornament_density: "rich",
      asset_creation_mode: "reuse_only",
      copy_style: "formal, warm",
      cultural_context_text: "Indian wedding",
      selected_assets: [],
      scene_instructions: [],
      notes: "",
      is_featured: false,
      is_premium: false,
    },
    stylePresets: [
      {
        id: "maroon-gold-palace",
        label: "Maroon Gold Palace",
        mood: "regal, cinematic, traditional",
        palette: {
          primary: "#5a1029",
          secondary: "#8a1738",
          accent: "#d4af37",
          background: "#2d0817",
          text: "#fff2d4",
        },
        prompt:
          "Create a royal Indian wedding mobile video invitation with a premium palace feel. Keep the opening grand and details pages readable.",
        typography:
          "High-contrast elegant serif display typography with readable classic serif detail text.",
        ornamentDensity: "ornate",
      },
      {
        id: "emerald-mehendi-royal",
        label: "Emerald Mehendi Royal",
        mood: "festive, rich, elegant",
        palette: {
          primary: "#0f3d35",
          secondary: "#1f6b52",
          accent: "#d8b85a",
          background: "#08231f",
          text: "#f8eed3",
        },
        prompt:
          "Create a royal Indian wedding invite with emerald and antique gold colors, mehendi-inspired patterns, and a premium festive mood.",
        typography: "Ornamental serif with graceful curves, paired with clean detail text.",
        ornamentDensity: "rich",
      },
      {
        id: "ivory-floral-luxury",
        label: "Ivory Floral Luxury",
        mood: "romantic, refined, graceful",
        palette: {
          primary: "#f5ead8",
          secondary: "#c9a875",
          accent: "#b76e79",
          background: "#fff8ec",
          text: "#563d2d",
        },
        prompt:
          "Create a soft luxury Indian wedding invite with ivory, champagne gold, blush floral accents, and refined spacing.",
        typography: "Romantic serif or calligraphic serif with warm readable body text.",
        ornamentDensity: "balanced",
      },
    ],
    assetGroups: [
      { value: "", label: "All groups" },
      { value: "background", label: "Backgrounds" },
      { value: "frame", label: "Frames & Arches" },
      { value: "mandala", label: "Mandalas" },
      { value: "divider", label: "Dividers" },
      { value: "floral", label: "Florals" },
      { value: "corner", label: "Corners" },
      { value: "overlay", label: "Overlays" },
    ],
    generatableAssetRoles: [
      {
        role: "hero_background",
        name: "Hero Background",
        group: "background",
        assetType: "image",
        required: true,
        placementSummary: "Scene 1 full-page background",
        placement: [{ sceneId: "scene-grand-opening", slot: "background.hero", mode: "cover", opacity: 1 }],
        usageTags: ["background", "opening", "hero_background"],
      },
      {
        role: "detail_background",
        name: "Detail Background",
        group: "background",
        assetType: "image",
        required: true,
        placementSummary: "Details and venue scenes full-page background",
        placement: [
          { sceneId: "scene-ceremony-details", slot: "background.details", mode: "cover", opacity: 1 },
          { sceneId: "scene-venue-address", slot: "background.venue", mode: "cover", opacity: 1 },
        ],
        usageTags: ["background", "details_page", "detail_background"],
      },
      {
        role: "royal_arch",
        name: "Royal Arch Frame",
        group: "frame",
        assetType: "svg",
        required: true,
        placementSummary: "Scene 1 central arch frame",
        placement: [{ sceneId: "scene-grand-opening", slot: "ornament.centerpiece", mode: "contain", opacity: 0.45 }],
        usageTags: ["arch", "frame", "opening", "royal_arch"],
      },
      {
        role: "mandala_centerpiece",
        name: "Mandala Centerpiece",
        group: "mandala",
        assetType: "svg",
        required: false,
        placementSummary: "Scene 1 lower decorative centerpiece",
        placement: [{ sceneId: "scene-grand-opening", slot: "ornament.centerpiece", mode: "contain", x: 250, y: 1088, width: 580, height: 580, opacity: 0.62 }],
        usageTags: ["mandala", "centerpiece", "ornament"],
      },
      {
        role: "divider_ornament",
        name: "Ornamental Divider",
        group: "divider",
        assetType: "svg",
        required: true,
        placementSummary: "Divider under key copy sections",
        placement: [
          { sceneId: "scene-invitation-message", slot: "divider.message", mode: "contain", x: 270, y: 675, width: 540, height: 68, opacity: 0.95 },
          { sceneId: "scene-ceremony-details", slot: "divider.details", mode: "contain", x: 300, y: 420, width: 480, height: 64, opacity: 0.95 },
        ],
        usageTags: ["divider", "details_page", "ornament"],
      },
      {
        role: "floral_cluster",
        name: "Floral Cluster",
        group: "floral",
        assetType: "svg",
        required: false,
        placementSummary: "Optional corner floral decoration",
        placement: [
          { sceneId: "scene-grand-opening", slot: "ornament.corner", mode: "contain", x: 60, y: 120, width: 240, height: 240, opacity: 0.8 },
          { sceneId: "scene-closing-rsvp", slot: "ornament.corner", mode: "contain", x: 780, y: 1480, width: 240, height: 240, opacity: 0.8 },
        ],
        usageTags: ["floral", "corner", "ornament"],
      },
    ],
  },
  birthday_mobile_video_v1: {
    id: "birthday_mobile_video_v1",
    label: "Birthday Mobile Video",
    description: "Short, cheerful 3-scene birthday invitation for quick party invites.",
    eventType: "birthday",
    eventTypeLabel: "Birthday",
    styleFamily: "celebration",
    styleFamilyLabel: "Celebration",
    format: "mobile_video",
    formatLabel: "Mobile Video",
    category: "Birthday",
    assetFamilyId: "birthday_mobile_video_v1",
    draftBuilder: "birthday_party",
    defaultSceneCount: 3,
    supportedSceneCounts: [3],
    defaultSubeventTypes: ["birthday_party"],
    defaultTags: ["ai_draft", "creative_brief", "admin_generated"],
    defaultStyleTags: ["birthday", "celebration", "playful", "ai-draft"],
    defaultCultureText: "birthday celebration",
    defaultCopyStyle: "cheerful, simple, warm",
    defaultForm: {
      template_name: "",
      event_type: "birthday",
      style_family: "celebration",
      format: "mobile_video",
      scene_count: 3,
      palette_text: "sunny yellow, coral pink, sky blue",
      palette_primary: "#ffbe3d",
      palette_secondary: "#ff6f91",
      palette_accent: "#32b8ff",
      palette_background: "#fff7d7",
      palette_text_color: "#3d2540",
      style_preset_id: "sunny-confetti",
      style_prompt:
        "Create a short cheerful birthday mobile video invitation with confetti, playful shapes, and clear party details.",
      mood_text: "joyful, playful, bright",
      typography_direction: "Bold rounded display typography with clean readable detail text.",
      ornament_density: "balanced",
      asset_creation_mode: "reuse_only",
      copy_style: "cheerful, simple, warm",
      cultural_context_text: "birthday celebration",
      selected_assets: [],
      scene_instructions: [],
      notes: "",
      is_featured: false,
      is_premium: false,
    },
    stylePresets: [
      {
        id: "sunny-confetti",
        label: "Sunny Confetti",
        mood: "joyful, playful, bright",
        palette: {
          primary: "#ffbe3d",
          secondary: "#ff6f91",
          accent: "#32b8ff",
          background: "#fff7d7",
          text: "#3d2540",
        },
        prompt:
          "Create a cheerful birthday invite with sunny yellow, coral pink, sky blue, rounded shapes, balloons, and confetti.",
        typography: "Bold rounded display typography with friendly readable details.",
        ornamentDensity: "balanced",
      },
      {
        id: "midnight-glow-party",
        label: "Midnight Glow Party",
        mood: "fun, energetic, modern",
        palette: {
          primary: "#17112f",
          secondary: "#7c3cff",
          accent: "#00e0ff",
          background: "#0d0922",
          text: "#fff4c7",
        },
        prompt:
          "Create a modern birthday party invite with dark neon glow, sparkles, and energetic celebration details.",
        typography: "Chunky modern display typography with high contrast details.",
        ornamentDensity: "rich",
      },
      {
        id: "pastel-cake-party",
        label: "Pastel Cake Party",
        mood: "sweet, soft, delightful",
        palette: {
          primary: "#ffd6e8",
          secondary: "#b8e6ff",
          accent: "#f7c948",
          background: "#fffaf2",
          text: "#55334d",
        },
        prompt:
          "Create a sweet pastel birthday invitation with cake-inspired details, soft balloons, and gentle festive spacing.",
        typography: "Soft rounded display typography with warm readable body text.",
        ornamentDensity: "balanced",
      },
    ],
    assetGroups: [
      { value: "", label: "All groups" },
      { value: "background", label: "Backgrounds" },
      { value: "balloon", label: "Balloons" },
      { value: "confetti", label: "Confetti" },
      { value: "cake", label: "Cake & Candles" },
      { value: "frame", label: "Frames" },
      { value: "overlay", label: "Overlays" },
    ],
    generatableAssetRoles: [
      {
        role: "party_background",
        name: "Party Background",
        group: "background",
        assetType: "image",
        required: true,
        placementSummary: "All birthday scenes full-page background",
        placement: [
          { sceneId: "scene-birthday-opening", slot: "background.opening", mode: "cover", opacity: 1 },
          { sceneId: "scene-birthday-details", slot: "background.details", mode: "cover", opacity: 1 },
          { sceneId: "scene-birthday-rsvp", slot: "background.rsvp", mode: "cover", opacity: 1 },
        ],
        usageTags: ["background", "birthday", "party_background"],
      },
      {
        role: "balloon_cluster",
        name: "Balloon Cluster",
        group: "balloon",
        assetType: "svg",
        required: false,
        placementSummary: "Opening scene hero celebration element",
        placement: [{ sceneId: "scene-birthday-opening", slot: "ornament.hero", mode: "contain", x: 230, y: 300, width: 620, height: 620, opacity: 0.9 }],
        usageTags: ["balloon", "birthday", "decor"],
      },
      {
        role: "confetti_overlay",
        name: "Confetti Overlay",
        group: "confetti",
        assetType: "svg",
        required: true,
        placementSummary: "Celebration overlay across all birthday scenes",
        placement: [
          { sceneId: "scene-birthday-opening", slot: "overlay.confetti", mode: "cover", opacity: 0.75 },
          { sceneId: "scene-birthday-details", slot: "overlay.confetti", mode: "cover", opacity: 0.45 },
          { sceneId: "scene-birthday-rsvp", slot: "overlay.confetti", mode: "cover", opacity: 0.45 },
        ],
        usageTags: ["confetti", "overlay", "celebration"],
      },
      {
        role: "cake_icon",
        name: "Cake Icon",
        group: "cake",
        assetType: "svg",
        required: false,
        placementSummary: "RSVP scene celebration icon",
        placement: [{ sceneId: "scene-birthday-rsvp", slot: "icon.rsvp", mode: "contain", x: 300, y: 360, width: 480, height: 360, opacity: 0.9 }],
        usageTags: ["cake", "birthday", "detail"],
      },
    ],
  },
  ganesh_chaturthi_mobile_video_v1: {
    id: "ganesh_chaturthi_mobile_video_v1",
    label: "Ganesh Chaturthi Mobile Video",
    description: "Devotional 5-scene Ganesh Chaturthi invitation for puja, aarti, prasad, venue, and a closing blessing.",
    eventType: "cultural_programs",
    eventTypeLabel: "Cultural Programs",
    styleFamily: "devotional_festive",
    styleFamilyLabel: "Devotional Festive",
    format: "mobile_video",
    formatLabel: "Mobile Video",
    category: "Cultural Programs",
    assetFamilyId: "ganesh_chaturthi_mobile_video_v1",
    draftBuilder: "ganesh_chaturthi",
    defaultSceneCount: 5,
    supportedSceneCounts: [5],
    defaultSubeventTypes: ["ganesh_chaturthi", "puja", "aarti", "prasad"],
    defaultTags: ["ai_draft", "creative_brief", "admin_generated", "ganesh_chaturthi"],
    defaultStyleTags: ["devotional", "festive", "ganpati", "cultural", "ai-draft"],
    defaultCultureText: "Ganesh Chaturthi devotional festival invitation",
    defaultCopyStyle: "warm, devotional, inviting",
    defaultForm: {
      template_name: "",
      event_type: "cultural_programs",
      style_family: "devotional_festive",
      format: "mobile_video",
      scene_count: 5,
      palette_text: "saffron, marigold, vermillion, antique gold, ivory",
      palette_primary: "#c2410c",
      palette_secondary: "#f59e0b",
      palette_accent: "#d4af37",
      palette_background: "#4a1208",
      palette_text_color: "#fff7d6",
      style_preset_id: "saffron-marigold-devotional",
      style_prompt:
        "Create a respectful Ganesh Chaturthi mobile video invitation with warm diya glow, marigold garlands, saffron and gold colors, and clear puja/program details.",
      mood_text: "devotional, auspicious, festive, warm",
      typography_direction: "Graceful devotional display typography with highly readable detail text.",
      ornament_density: "rich",
      asset_creation_mode: "reuse_only",
      copy_style: "warm, devotional, inviting",
      cultural_context_text: "Ganesh Chaturthi",
      selected_assets: [],
      scene_instructions: [],
      notes: "",
      is_featured: false,
      is_premium: false,
    },
    stylePresets: [
      {
        id: "saffron-marigold-devotional",
        label: "Saffron Marigold Devotional",
        mood: "devotional, auspicious, festive, warm",
        palette: {
          primary: "#c2410c",
          secondary: "#f59e0b",
          accent: "#d4af37",
          background: "#4a1208",
          text: "#fff7d6",
        },
        prompt:
          "Create a Ganesh Chaturthi invitation with saffron, marigold, vermillion, antique gold, diya glow, and respectful Ganesha-inspired motifs.",
        typography: "Graceful serif display typography with readable warm detail text.",
        ornamentDensity: "rich",
      },
      {
        id: "ivory-gold-puja",
        label: "Ivory Gold Puja",
        mood: "serene, devotional, elegant",
        palette: {
          primary: "#fff3cf",
          secondary: "#f4c430",
          accent: "#b45309",
          background: "#7c2d12",
          text: "#3d1f0f",
        },
        prompt:
          "Create an elegant Ganesh Chaturthi puja invite with ivory, gold, soft marigold details, warm light, and uncluttered readable layouts.",
        typography: "Elegant devotional serif paired with simple readable details.",
        ornamentDensity: "balanced",
      },
      {
        id: "emerald-saffron-ganpati",
        label: "Emerald Saffron Ganpati",
        mood: "festive, premium, vibrant",
        palette: {
          primary: "#0f5132",
          secondary: "#f97316",
          accent: "#facc15",
          background: "#082f24",
          text: "#fff8dc",
        },
        prompt:
          "Create a premium Ganesh Chaturthi invite with emerald, saffron, gold, rangoli accents, diya glow, and festive devotional energy.",
        typography: "Premium serif display typography with clear high-contrast detail text.",
        ornamentDensity: "rich",
      },
    ],
    assetGroups: [
      { value: "", label: "All groups" },
      { value: "background", label: "Backgrounds" },
      { value: "deity", label: "Ganesha Motifs" },
      { value: "floral", label: "Marigold & Florals" },
      { value: "diya", label: "Diyas & Glow" },
      { value: "divider", label: "Dividers" },
      { value: "overlay", label: "Overlays" },
      { value: "icon", label: "Icons" },
    ],
    generatableAssetRoles: [
      {
        role: "ganesha_hero_background",
        name: "Ganesh Chaturthi Stage Background",
        group: "background",
        assetType: "image",
        required: true,
        placementSummary: "Scene 1 full-page static stage background without Ganesha or movable decor",
        placement: [{ sceneId: "scene-ganesh-opening", slot: "background.hero", mode: "cover", opacity: 1 }],
        usageTags: ["ganesh_chaturthi", "background", "hero", "devotional", "static_stage", "no_deity", "no_movable_decor"],
      },
      {
        role: "ganesha_icon_or_silhouette",
        name: "Ganesha Icon or Silhouette",
        group: "deity",
        assetType: "svg",
        required: true,
        placementSummary: "Scene 1 devotional centerpiece",
        placement: [{ sceneId: "scene-ganesh-opening", slot: "ornament.centerpiece", mode: "contain", opacity: 0.92 }],
        usageTags: ["ganesha", "ganpati", "silhouette", "devotional"],
      },
      {
        role: "marigold_frame",
        name: "Marigold Top Garland",
        group: "floral",
        assetType: "svg",
        required: true,
        placementSummary: "Opening top garland that drops from above; reusable as restrained closing decor",
        placement: [
          { sceneId: "scene-ganesh-opening", slot: "frame.top", mode: "contain", opacity: 0.92 },
          { sceneId: "scene-ganesh-closing", slot: "frame.closing", mode: "contain", opacity: 0.58 },
        ],
        usageTags: ["marigold", "garland", "top_garland", "festival", "decor"],
      },
      {
        role: "diya_glow_overlay",
        name: "Diya Glow Overlay",
        group: "diya",
        assetType: "image",
        required: true,
        placementSummary: "Warm glow overlay on opening and closing scenes",
        placement: [
          { sceneId: "scene-ganesh-opening", slot: "overlay.glow", mode: "cover", opacity: 0.38 },
          { sceneId: "scene-ganesh-closing", slot: "overlay.glow", mode: "cover", opacity: 0.24 },
        ],
        usageTags: ["diya", "glow", "overlay", "auspicious"],
      },
      {
        role: "modak_icon",
        name: "Modak Icon",
        group: "icon",
        assetType: "svg",
        required: false,
        placementSummary: "Optional Scene 3 prasad detail",
        placement: [{ sceneId: "scene-ganesh-details", slot: "icon.prasad", mode: "contain", opacity: 0.9 }],
        usageTags: ["modak", "ganesh_chaturthi", "detail"],
      },
      {
        role: "lotus_divider",
        name: "Lotus Divider",
        group: "divider",
        assetType: "svg",
        required: true,
        placementSummary: "Divider below host/details headings",
        placement: [
          { sceneId: "scene-ganesh-host", slot: "divider.host", mode: "contain", opacity: 0.9 },
          { sceneId: "scene-ganesh-details", slot: "divider.details", mode: "contain", opacity: 0.9 },
        ],
        usageTags: ["lotus", "divider", "devotional"],
      },
      {
        role: "rangoli_floor_accent",
        name: "Rangoli Floor Accent",
        group: "overlay",
        assetType: "svg",
        required: false,
        placementSummary: "Optional animated lower-floor accent on opening and closing scenes",
        placement: [
          { sceneId: "scene-ganesh-opening", slot: "ornament.floor", mode: "contain", x: 240, y: 1460, width: 600, height: 260, opacity: 0.76 },
          { sceneId: "scene-ganesh-closing", slot: "ornament.floor", mode: "contain", x: 260, y: 1390, width: 560, height: 240, opacity: 0.48 },
        ],
        usageTags: ["rangoli", "floor", "accent", "devotional", "animated_layer"],
      },
    ],
  },
};

export const DEFAULT_TEMPLATE_FAMILY_ID = "royal_indian_wedding_mobile_video_v1";

export function getTemplateFamily(familyId = DEFAULT_TEMPLATE_FAMILY_ID) {
  return TEMPLATE_FAMILIES[familyId] || TEMPLATE_FAMILIES[DEFAULT_TEMPLATE_FAMILY_ID];
}

export function getTemplateFamilyOptions() {
  return Object.values(TEMPLATE_FAMILIES).map((family) => ({
    value: family.id,
    label: family.label,
    description: family.description,
  }));
}

export function buildDefaultCreativeBrief(familyId = DEFAULT_TEMPLATE_FAMILY_ID) {
  const family = getTemplateFamily(familyId);
  return {
    ...family.defaultForm,
    selected_assets: [],
    template_asset_bindings: [],
    scene_instructions: [],
  };
}
